import { Button, Card, Col, Row, Typography } from "antd"
import { CopyOutlined, MenuOutlined ,MessageOutlined} from "@ant-design/icons"
import { EditButton, DeleteButton } from "../../../shared"
import {
  implementer,
  getReadableValue
} from "../../../../helpers/selectOptions"
import PropTypes from "prop-types"
import { Draggable } from "react-beautiful-dnd"
import { submission } from "../../../../graphql"
import { CommentButton} from "../../../admin/submissions/review"
import { useContext, useEffect, useState } from "react"

import { CommentsContext } from "../../../../contexts/admin/submissions/review/comments/context"
import { BlockComponent } from "../../../../helpers/blockComponent"
import { LockOutlined, UnlockOutlined } from "@ant-design/icons"


IndicatorItem.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  readOnly: PropTypes.bool,
  review: PropTypes.bool,
  index: PropTypes.number,
  indicatorType: PropTypes.string,
  objectiveIndex: PropTypes.any,
  onDuplicate: PropTypes.func
}

export function IndicatorItem({ data, onDelete, onEdit, onDuplicate, readOnly, review, index, indicatorType, objectiveIndex, commentID, admin, rol }) {
  const {
    title = "Indicador sin título",
    description = "N/A",
    methodology = "N/A",
    baseline = "N/A",
    goal = "N/A",
    formula = "N/A",
    orderIndex,
    key,
    meansOfVerification = []
  } = data

  const { submission: { verificationTypes } } = implementer

  const { updateEntities } = useContext(CommentsContext)

  useEffect(() => {
    if (commentID) {
      commentID && updateEntities([{ entity: "indicator", id: commentID, type: indicatorType  }])
    }
  }, [commentID, indicatorType])

  const [Block, setBlock] = useState(data.isBlocking);
  const [BlockDelete, setBlockDelete] = useState(false);
  const [TotalComment, setTotalComment] = useState(0);

  const bloquearTest = () =>{
    setBlock(!Block)
  }

  useEffect(()=>{
    if(TotalComment > 0 && rol){
      setBlockDelete(true)
    }
  },[TotalComment])


  let bottonsblock = data.isBlocking && rol


  return (
    <Draggable
      index={index}
      isDragDisabled={readOnly}
      key={`indicator_${indicatorType}_${objectiveIndex}_${index}`}
      draggableId={
       `indicator_${indicatorType}_${objectiveIndex}_${index}`
      }>
      {draggableProvided => (
        <div ref={draggableProvided.innerRef} {...draggableProvided.draggableProps}>
          <Card key={`indicator_${key}`} style={{ paddingLeft: 0, marginBottom: "20px" }}>
            <Row style={{ width: "100%" }}>
              <Col span={1} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <MenuOutlined {...draggableProvided.dragHandleProps} />
              </Col>
              <Col span={21}>
                <Typography.Text strong>
                  Indicador {+orderIndex + 1 }: {title}
                </Typography.Text>
                <br />
                <Typography.Text type="secondary">
                  {description || "N/A"}
                </Typography.Text>
                <br />
                <Typography.Text strong>Metodología: </Typography.Text>
                <Typography.Text>
                  {methodology || "N/A"}
                </Typography.Text>
                <br />
                <Typography.Text strong>Línea base: </Typography.Text>
                <Typography.Text>{baseline || "N/A"}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Meta: </Typography.Text>
                <Typography.Text>{goal || "N/A"}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Fórmula: </Typography.Text>
                <Typography.Text>{formula || "N/A"}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Medio de verificación: </Typography.Text>
                <Typography.Text>
                  {meansOfVerification?.length ? (
                    meansOfVerification.map(method => getReadableValue(verificationTypes, method)).join(", ")
                  ) : "N/A"}
                </Typography.Text>

              </Col>
              <Col
                span={2}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: 'center',
                  gap: "4px"
                }}>
                {(!readOnly && !review && !bottonsblock && !BlockDelete) &&
                  <DeleteButton
                    onClick={onDelete}
                  />
                }
                {
                  admin &&
                  <Button
                    style={{ float: "right"}}
                    size="medium"
                    shape="circle"
                    icon={Block ? <LockOutlined style={{ color: '#e01717' }}/> : <UnlockOutlined style={{ color: '#43b61c' }}/>}
                    onClick={() => {
                      let newData = {
                        ...data,
                        isBlocking:!Block
                      }
                      BlockComponent(newData,"","indicador", bloquearTest)
                    }} />
                }
                <EditButton onClick={onEdit} />
                {(!readOnly && !review && onDuplicate && !bottonsblock) &&
                  <Button
                    onClick={() => {
                      // treat the duplicated item as a new item without id
                      // eslint-disable-next-line no-unused-vars
                      const { id, metodologyDocuments, ...item } = data
                      onDuplicate({
                        ...item,
                        metodologyDocuments: (metodologyDocuments || []).map(doc => ({
                          name: doc.name,
                          url: doc.url
                        }))
                      })
                    }}
                    shape="circle"
                    size="middle">
                    <CopyOutlined />
                  </Button>
                }
                <CommentButton
                  isSpecSheet={true} idSpecSheet={"indicator"}
                  countComments={setTotalComment}
                  entityId={commentID} />
              </Col>
            </Row>
          </Card>
        </div>
      )}
    </Draggable>
  )
}
